import React from "react"
import { Row, Col, Button } from "react-bootstrap"
import Section from "./section"

const Text = ({ data }) => {
  const { heading, subhead, desc, cta, layout, relationships, anchor } = data

  const field_image = relationships.field_image //null if no image uploaded
 // console.log(field_image)

  return (
    <Section name="text" id={anchor} heading={heading} subhead={subhead}>
      {layout === "img_left_txt_right" && (
        <Row className="d-flex flex-column flex-md-row page__blurb">
          {!!field_image && (
            <Col className="img" xl={4} md={6}>
              <img
                src={
                  field_image.relationships.image.localFile.childImageSharp
                    .original.src
                }
                alt=""
              />
            </Col>
          )}
          <Col
            className="desc text-left"
            dangerouslySetInnerHTML={{ __html: desc.processed }}
          ></Col>
        </Row>
      )}
      {layout === "img_right_txt_left" && (
        <Row className="d-flex flex-column flex-md-row page__blurb">
          <Col
            className="desc text-left order-2 order-md-1"
            dangerouslySetInnerHTML={{ __html: desc.processed }}
          ></Col>
          {!!field_image && (
            <Col className="img order-1 order-md-2" xl={4} md={6}>
              <img
                src={
                  field_image.relationships.image.localFile.childImageSharp
                    .original.src
                }
                alt=""
              />
            </Col>
          )}
        </Row>
      )}
      {layout === "txt_top_img_bottom" && (
        <Row className="d-flex flex-column page__blurb">
          <Col
            className="desc text-left"
            dangerouslySetInnerHTML={{ __html: desc.processed }}
          ></Col>
          {!!field_image && (
            <Col className="img">
              <img
                src={
                  field_image.relationships.image.localFile.childImageSharp
                    .original.src
                }
                alt=""
              />
            </Col>
          )}
        </Row>
      )}

      {!!cta && (
        <div className="section__text-cta text-center">
          <Button variant="primary" className="btn-submit" href={cta.uri}>
            {cta.title}
          </Button>
        </div>
      )}
    </Section>
  )
}

export default Text
